import React from 'react';
import CompanyMenu from './company-menu'
import { auth } from '../../Api';
import { Select } from 'antd';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import DashboardTabDuties from './dashboard-tab-duties';
import * as cx from 'classnames'
import DashboardTabReport from './dashboard-tab-report';
import DashboardTabGraphics from './dashboard-tab-graphics';
var tzOffset = require("tz-offset")
import Loader from '../../layouts/loader/Loader'
import mapuserBlue from '../../assets/images/mapuser-blue.png'
import mapuserRed from '../../assets/images/mapuser-red.png'

class Dashboard extends React.Component {
    
    constructor(props) {
        super(props);
        let companyId = localStorage.getItem('companyId')

        // Before-first-load placeholder only: seeds state.points so the map
        // isn't centered on the hardcoded Nairobi fallback while the first
        // real getGuard() response is in flight. Scoped per company (not a
        // shared 'points' key) and validated the same way as fresh API data,
        // since a corrupted cache entry would otherwise replay indefinitely
        // across every company/session.
        var points = []
        var cachedPointsRaw = localStorage.getItem('points_' + companyId)
        if (cachedPointsRaw != null) {
            try {
                var cachedPoints = JSON.parse(cachedPointsRaw)
                if (Array.isArray(cachedPoints)) {
                    points = cachedPoints.filter(p => p && Number.isFinite(p.lat) && Number.isFinite(p.lng))
                }
            } catch (e) {
                points = []
            }
        }

        var selectType = localStorage.getItem('selectType')
        var whichCompany = localStorage.getItem('whichCompany')

        if (whichCompany != null && companyId != null) {
            if (whichCompany != companyId) {
                localStorage.setItem('whichCompany', companyId)
                selectType = 'company:company:' + companyId
                localStorage.setItem('selectType', selectType)
            } else {
                if (selectType == null) {
                    selectType = 'company:company:' + companyId
                }
            }
        }
        if (whichCompany == null && companyId != null) {
            localStorage.setItem('whichCompany', companyId)
            selectType = 'company:company:' + companyId
        }
        let refreshGuard = localStorage.getItem('refreshGuard')
        this.state = {
            loadingDashboard: false,
            loadingGuard: false,
            color: ["#00264d", "#0066cc", "#4da6ff", "#004d99", "#0080ff", "#99ccff"],
            jsonData: {},
            markers: [],
            markerGuards:[],
            activeMarker: {},
            selectedPlace: {},
            showInfoWindow: false,
            selectType: selectType,
            options: [],
            adminOptions:[],
            activeMarker: null,
            selectedPlace: null,
            mapCenter: {
                lat: -1.052,
                lng: 37.098
            },
            points: points,
            refreshGuard: refreshGuard,
            companyId: companyId,
            selectedTab: 0,
            periodOptions:[
                {
                    label: 'Last 6 months',
                    value: "6month"
                },
                {
                    label: 'Last month',
                    value: "month"
                },
                {
                    label: 'Last week',
                    value: "week"
                },
                {
                    label: 'Last day',
                    value: "day"
                },
            ]
        }
    }

    mapRef = React.createRef();

    onMarkerClick = (props, marker) => {
        this.setState({
            activeMarker: marker,
            selectedPlace: props,
            showInfoWindow: true,
        });
    };

    handleMouseOver = (props, marker, e) => {
        this.setState({
            activeMarker: marker,
            selectedPlace: props,
        });
    };

    handleMouseOut = () => {
        this.setState({
            activeMarker: null,
            selectedPlace: null,
        });
    };

    onCloseInfoWindow = () => {
        this.setState({
            activeMarker: {},
            selectedPlace: {},
            showInfoWindow: false,
        });
    };

    onSecondCityChange = (value) => {
        console.log(value)
        this.setState({ selectType: value });
        localStorage.setItem('selectType', value);
        localStorage.setItem('whichCompany', this.state.companyId);
        var req = {}
        req.type = value.split(":")[0]
        req.id = value.split(":")[2]
        this.setState({ loadingGuard: true })
        this.getGuard(req)
    };

    componentDidMount() {
        let { selectType, companyId } = this.state
        var req = {}
        req.type = selectType.split(":")[0]
        req.id = selectType.split(":")[2]
        this.setState({ loadingGuard: true })
        this.getGuard(req)

        var req = {}
        req.company_id = companyId
        this.setState({ loadingDashboard: true })
        auth.getDashboard(req)
            .then((res) => {
                if (res.data.code == 200) {

                    var adminOptions =[]
                    res.data.message.admin.forEach(element => {
                        adminOptions.push({
                            label: 'Admin',
                            value: 'admin' + ':' + element.name + ":" + element.id,
                        })
                    });
                    var adminCover = {
                        label: 'Admin',
                        options: adminOptions
                    }
                    
                    var districtsOption = []
                    res.data.message.districts.forEach(element => {
                        districtsOption.push({
                            label: element.name,
                            value: 'district' + ':' + element.name + ":" + element.id,
                        })
                    });
                    var districtsCover = {
                        label: 'Districts',
                        options: districtsOption
                    }
                    var districtsManagerOption = []
                    res.data.message.districtmanagers.forEach(element => {
                        districtsManagerOption.push({
                            label: element.name,
                            value: 'districtmanager' + ':' + element.name + ":" + element.id,
                        })
                    })
                    var districtsManagerCover = {
                        label: 'DistrictManagers',
                        options: districtsManagerOption
                    }

                    var clientsOption = []
                    res.data.message.clients.forEach(element => {
                        clientsOption.push({
                            label: element.name,
                            value: 'client' + ':' + element.name + ":" + element.id,
                        })
                    });
                    var clientsCover = {
                        label: 'Clients',
                        options: clientsOption
                    }

                    var supervisorsOption = []
                    res.data.message.supervisors.forEach(element => {
                        supervisorsOption.push({
                            label: element.firstname + " " + element.secondname,
                            value: 'supervisor' + ':' + element.firstname + " " + element.secondname + ":" + element.id,
                        })
                    });
                    var supervisorsCover = {
                        label: 'Supervisors',
                        options: supervisorsOption
                    }
                    this.setState({
                        jsonData: res.data.message,
                        supervisors: res.data.message.supervisors,
                        clients: res.data.message.clients,
                        districtmanagers: res.data.message.districtmanagers,
                        districts: res.data.message.districts,
                        guards: res.data.message.guards,
                        adminOptions: adminCover,
                        options: [
                            {
                                label: 'Company',
                                value: 'company' + ':' + "company:" + companyId
                            },
                            districtsCover,
                            districtsManagerCover,
                            supervisorsCover,
                            clientsCover
                        ]
                    })
                }
            })
            .finally(() => {
                this.setState({ loadingDashboard: false })
            })
    }

    getGuard(req) {
        if (this.state.refreshGuard != null) {
            window.clearTimeout(this.state.refreshGuard)
        }
        this.setState({ loadingGuard: true })
        auth.getGuards(req)
            .then((res) => {
                if (res.data.message.guards.length > 0) {
                    var markers = [];
                    var points = [];
                    var currentMilli = new Date().getTime()
                    var companyInfo = JSON.parse(localStorage.getItem('companyInfo'))
                    var dutyTimeOffset = tzOffset.offsetOf(companyInfo.timezone)
                    let currentOffset = (new Date()).getTimezoneOffset()
                    let targetOffset = currentOffset - dutyTimeOffset

                    res.data.message.guards.forEach(element => {
                        if (element.locations != null) {
                            var lat = parseFloat(element.locations.latitude)
                            var lng = parseFloat(element.locations.longitude)
                            if (isNaN(lat) || isNaN(lng)) {
                                console.warn("Skipping guard with invalid GPS coordinates - guard id:", element.id,
                                    "latitude:", element.locations.latitude, "longitude:", element.locations.longitude)
                                return
                            }
                            var online = currentMilli - element.locations.time > 240 * 1000 ? "red" : "blue"
                            var iconUrl = online === "blue" ? mapuserBlue : mapuserRed
                            var missed_alert = "count:" + res.data.message["guards" + element.id].length.toString()
                            var label = " "
                            if (res.data.message["guards" + element.id].length > 0) {
                                var missed_alert = "count:" + res.data.message["guards" + element.id].length.toString()
                                res.data.message["guards" + element.id].map((prop, key) => {
                                    var time = new Date(parseInt(targetOffset != null ? prop.DateTime + targetOffset * 60 * 1000 : prop.DateTime))
                                    var strTime = (time.getHours() < 10 ? "0" + time.getHours() : time.getHours())
                                        + ":"
                                        + (time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes());
                                    missed_alert = missed_alert + "\n    " + strTime
                                })
                                label = res.data.message["guards" + element.id].length.toString()
                            }
                            markers.push({
                                id: element.id, lat: lat,
                                lng: lng,
                                title: "Name: " + element.firstname + " " + element.secondname +
                                    // "\nLocation: " + "lat--"+element.locations.latitude + " long--" + element.locations.longitude +
                                    "\nLocation: " + element.location_name +
                                    "\nSupervisor: " + element.s_fname + " " + element.s_sname +
                                    "\nMissed alert: " + missed_alert,
                                label: label,
                                email: element.email,
                                phone: element.phone,
                                iconUrl: iconUrl,
                            })
                            points.push({
                                lat: lat,
                                lng: lng
                            })
                        }
                    })
                    var refresh = window.setTimeout(() => {
                        this.getGuard(req)
                    }, 60 * 1000)
                    localStorage.setItem("points_" + this.state.companyId, JSON.stringify(points))
                    localStorage.setItem('refreshGuard', refresh)
                    this.setState({
                        markers: markers,
                        points: points,
                        refreshGuard: refresh,
                        markerGuards: res.data.message.guards
                    })
                }
            })
            .finally(() => {
                this.setState({ loadingGuard: false })
            })

    }

    render() {
        const { google } = this.props;
        const { activeMarker, selectedPlace, selectedTab } = this.state;
        let { options, selectType, points, adminOptions } = this.state
        var bounds = new this.props.google.maps.LatLngBounds();
        if (points.length == 0) {
            points = [
                {
                    lat: -1.2359261173160285, lng: 36.88208275644852
                }, {
                    lat: -1.3502234592717233, lng: 36.75059014668507
                }]
        }
        for (var i = 0; i < points.length; i++) {
            bounds.extend(points[i]);
        }
        return (
            <div>
                <Loader isLoading={this.state.loadingDashboard || this.state.loadingGuard} />
                <CompanyMenu></CompanyMenu>
                <div className="height-10"></div>
                <div className='tablink-cover'>
                    <button className={cx("tablink", selectedTab==0?"selected":"")} onClick={() => { this.setState({ selectedTab: 0 }) }}>Map</button>
                    <button className={cx("tablink", selectedTab==1?"selected":"")} onClick={() => { this.setState({ selectedTab: 1 }) }}>Duties</button>
                    <button className={cx("tablink", selectedTab==2?"selected":"")} onClick={() => { this.setState({ selectedTab: 2 }) }}>Graphics</button>
                    <button className={cx("tablink", selectedTab==3?"selected":"")} onClick={() => { this.setState({ selectedTab: 3 }) }}>Report</button>
                </div>
                <div style={{ height: 'calc(100vh - 280px)', width: '100%', position: 'relative', display: selectedTab == 0 ? 'block' : 'none' }} id="MapTab">
                    <div style={{ 'bottom': '10px', 'left': '10px', 'zIndex': '15', position: 'absolute' }}>
                        <Select
                            style={{ width: 140 }}
                            value={selectType.split(":")[1]}
                            onChange={this.onSecondCityChange}
                            options={options}
                        />
                    </div>
                    <Map
                        google={this.props.google}
                        style={{ width: "100%", margin: "auto" }}
                        className="company-map"
                        ref={this.mapRef}
                        initialCenter={{
                            lat: -1.052,
                            lng: 37.098
                        }}
                        bounds={bounds}
                        onWheel={this.wheel}
                    >
                        {this.state.markers.map((marker, index) => (

                            <Marker
                                icon={{
                                    // url: "https://laravel.mobiliis.com/public/storage/mapuser-"+marker.online==1?"blue.png":"red.png",
                                    url: marker.iconUrl,
                                    labelOrigin: new google.maps.Point(18, -10),
                                    scaledSize: new google.maps.Size(36, 36)
                                }}
                                key={index}
                                label={{
                                    text: `${marker.label}`,
                                    color: 'black',
                                    fontSize: '22px',
                                    fontWeight: '900',
                                }}
                                title={marker.title}
                                // title={{text:marker.title,className:'marker-label'}}
                                name={marker.name}
                                email={marker.email}
                                phone={marker.phone}
                                position={{ lat: marker.lat, lng: marker.lng }}
                                onMouseover={() => { console.log("hover mouse in marker:", marker.title) }}
                                labelClass='marker-label'

                            // labelAnchor={new google.maps.Point(35, 27)}
                            />
                        ))}
                        <InfoWindow
                            marker={activeMarker}
                            visible={!!activeMarker}
                            onClose={this.handleMouseOut}
                        >
                            <div>
                                <h4>{selectedPlace && selectedPlace.name}</h4>
                                <h5>{selectedPlace && selectedPlace.email}</h5>
                                <h5>{selectedPlace && selectedPlace.phone}</h5>
                            </div>
                        </InfoWindow>
                    </Map>
                </div>
                {selectedTab == 1 ? <div style={{ height: 'calc(100vh - 280px)', width: '100%', position: 'relative'}} id="DutiesTab">
                    <DashboardTabDuties selectOptions={options} periodOptions={this.state.periodOptions}/>
                </div>:<></>}
                {selectedTab == 2 ? <div style={{ height: 'calc(100vh - 280px)', width: '100%', position: 'relative'}} id="GraphicTab">
                    <DashboardTabGraphics selectOptions={options} periodOptions={this.state.periodOptions}/>
                </div>:<></>}
                {selectedTab == 3 ? <div style={{ height: 'calc(100vh - 280px)', width: '100%', 
                    overflowY: 'auto',
                    position: 'relative'}} id="ReportTab">
                    <DashboardTabReport adminOptions={adminOptions} selectOptions={options} periodOptions={this.state.periodOptions}/>
                </div>:<></>}
            </div>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyAKXMyJn1D2_AnCvqiAt7JKj77ZTD7N4Ys"
})(Dashboard);
